import { useMemo } from 'react'

import { useMainBuyerOrRenter } from '@app/hooks'
import { Conversation } from '@app/models'

import { BuyerLocale } from './types'

export const useMainBuyerLocale = (
  conversation: Conversation | null
): BuyerLocale => {
  const mainBuyerOrRenter = useMainBuyerOrRenter(conversation)

  return useMemo(() => {
    if (!mainBuyerOrRenter) {
      return {}
    }

    const language = mainBuyerOrRenter.language
    const country = mainBuyerOrRenter.countryISO

    const normalizedLanguage = language ? language.toLowerCase() : undefined
    const normalizedCountry = country ? country.toUpperCase() : undefined

    const culture =
      normalizedLanguage && normalizedCountry
        ? `${normalizedLanguage}-${normalizedCountry}`
        : undefined

    return { culture, language: normalizedLanguage }
  }, [mainBuyerOrRenter])
}
